"use strict";

require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.regexp.test.js");
require("core-js/modules/es.number.to-fixed.js");
var _paulCorePackage = require("paul-core-package");
var _react = _interopRequireWildcard(require("react"));
var _reactRedux = require("react-redux");
var _ValueModule = _interopRequireDefault(require("../../styles/components/Circles/Value.module.css"));
var _useGetValue = require("../../hooks/useGetValue");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const Value = _ref => {
  var _useSelector;
  let {
    thingPDIDDevice,
    isCorrect = false,
    displayNameId
  } = _ref;
  const isTemperature = (0, _react.useMemo)(() => _paulCorePackage.constants.regularsByDisplayNameId.temperatureRegex.test(displayNameId), [displayNameId]);
  const {
    value: _value,
    valueType = {},
    unit
  } = (0, _useGetValue.useGetDeviceValueByParams)({
    displayNameId,
    thingPDIDDevice
  });
  const value = (0, _react.useMemo)(() => valueType === _paulCorePackage.constants.valueType.float ? +_value : null, [_value, valueType]);
  const tVUnit = (_useSelector = (0, _reactRedux.useSelector)(_paulCorePackage.selectors.getActiveTranslationsValues)) === null || _useSelector === void 0 || (_useSelector = _useSelector.Default) === null || _useSelector === void 0 ? void 0 : _useSelector.unit;
  const tUnit = (0, _react.useMemo)(() => tVUnit ? tVUnit[unit] : '', [tVUnit, unit]);
  return (0, _react.useMemo)(() => /*#__PURE__*/_react.default.createElement("div", {
    className: _ValueModule.default.box
  }, /*#__PURE__*/_react.default.createElement("span", null, isCorrect && value != null ? value.toFixed(1) : '- -'), /*#__PURE__*/_react.default.createElement("span", {
    className: "".concat(_ValueModule.default.unit, " ").concat(isTemperature ? _ValueModule.default.on_top : '')
  }, tUnit)), [isCorrect, value, tUnit, isTemperature]);
};
var _default = exports.default = Value;